export const apiSetZoom = (map, options) => {
  if (map) {
    if (options.zoom !== undefined) {
      map.map.setZoom(options.zoom)
      map.raw_options.zoom = options.zoom
    }
  }
}
